import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const PhonebookFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M18.7 3L8.30001 3C6.87001 3 5.70001 4.16 5.70001 5.6L5.70001 18.4C5.70001 19.83 6.86001 21 8.30001 21H18.7C20.13 21 21.3 19.84 21.3 18.4V5.6C21.3 4.17 20.14 3 18.7 3ZM17.73 15.46L17.43 15.72C17.22 15.93 16.56 16.52 15.46 16.54C14.14 16.55 12.74 15.73 11.31 14.08C9.88001 12.44 9.26001 10.94 9.46001 9.63C9.62001 8.54 10.3 7.97 10.54 7.79L10.84 7.53C11.39 7.05 11.82 7.46 12.22 8.07L12.46 8.44C12.85 9.06 13.06 9.66 12.51 10.13L12.18 10.42C11.94 10.63 10.91 10.94 12.64 12.92C14.37 14.91 14.81 13.93 15.05 13.72L15.38 13.43C15.93 12.95 16.49 13.24 17.05 13.72L17.38 14.01C17.94 14.49 18.28 14.97 17.73 15.45V15.46Z"
      fill={color}
    />
    <Path
      d="M5.22003 14.96H4.24003C3.74003 14.96 3.34003 15.36 3.34003 15.86C3.34003 16.36 3.74003 16.76 4.24003 16.76H5.22003V14.96Z"
      fill={color}
    />
    <Path
      d="M5.22003 11.03H4.24003C3.74003 11.03 3.34003 11.43 3.34003 11.93C3.34003 12.43 3.74003 12.83 4.24003 12.83H5.22003V11.03Z"
      fill={color}
    />
    <Path
      d="M5.22003 7.09998H4.24003C3.74003 7.09998 3.34003 7.49998 3.34003 7.99998C3.34003 8.49998 3.74003 8.89998 4.24003 8.89998H5.22003V7.09998Z"
      fill={color}
    />
  </Svg>
)

export default PhonebookFilled
